/*
**************************** 
홈페이지 콘텐츠 - 영어
*****************************
*/

import React from "react";

export default function English(props) {

    return (
        <div>
            <div className="mt-5 pt-2">
                <ol className="breadcrumb">
                    <li className="breadcrumb-item small"><a href="#">고객센터</a></li>
                    <li className="breadcrumb-item active small">FAQ</li>
                </ol>
                <ul className="nav nav-tabs d-flex justify-content-center" role="tablist">
                    <li className="nav-item  medium " role="presentation" >
                        <a className="nav-link active text-black text-decoration-none " data-bs-toggle="tab" href="#hodooabc" aria-selected="true" role="tab" tabIndex="-1">호두ABC</a>
                    </li>
                    <li className="nav-item  medium" role="presentation">
                        <a className="nav-link  text-black text-decoration-none" data-bs-toggle="tab" href="#betia1betia2" aria-selected="false" role="tab" tabIndex="-1">베티아 잉글리시1 / 베티아 잉글리시2</a>
                    </li>
                    <li className="nav-item medium" role="presentation">
                        <a className="nav-link  text-black text-decoration-none" data-bs-toggle="tab" href="#leadingn" aria-selected="false" role="tab" tabIndex="-1">리딩엔 인성동화 60종</a>
                    </li>
                    <li className="nav-item medium" role="presentation">
                        <a className="nav-link  text-black text-decoration-none" data-bs-toggle="tab" href="#jungsang" aria-selected="false" role="tab" tabIndex="-1">정상어학원 Hello Chess 화상수업</a>
                    </li>
                </ul>
            </div>
            <div className="container mt-3">
                <div id="myTabContent" className="tab-content">
                    <div className="tab-pane  active show" id="hodooabc" role="tabpanel">
                        <div className="container-custom w-100">
                            <img className="img-fluid" src="/img/school/hodooabc_l4box.png"></img>
                        </div>
                    </div>
                    <div className="tab-pane fade" id="betia1betia2" role="tabpanel">
                        <div className="container-custom w-100">
                            <img className="img-fluid" src="/img/school/betia.png"></img>
                        </div>
                    </div>
                    <div className="tab-pane fade" id="leadingn" role="tabpanel">
                        <div className="container-custom w-100">
                            <img className="img-fluid" src="/img/school/reading.png"></img>
                        </div>
                    </div>
                    <div className="tab-pane fade" id="jungsang" role="tabpanel">
                        <div className="container-custom w-100">
                            <img className="img-fluid" src="/img/school/hellochess.png"></img>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}